import { render, staticRenderFns } from "./GalleryThumb.vue?vue&type=template&id=2958b50c"
import script from "./GalleryThumb.vue?vue&type=script&lang=js"
export * from "./GalleryThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports